/**
 * Marlow Product Videos - Gallery with thumbnail navigation
 * Click thumbnail to switch main video
 */

class MarlowVideoGallery {
  constructor(sectionId) {
    this.sectionId = sectionId;
    this.section = document.querySelector(`.marlow-videos[data-section-id="${sectionId}"]`);
    
    if (!this.section) {
      console.warn(`[VideoGallery] Section ${sectionId} not found`);
      return;
    }
    
    this.init();
  }
  
  init() {
    this.cacheElements();
    this.bindEvents();
    
    console.log('[VideoGallery] Initialized');
  }
  
  cacheElements() {
    this.thumbs = this.section.querySelectorAll('[data-video-thumb]');
    this.players = this.section.querySelectorAll('[data-video-player]');
  }
  
  bindEvents() {
    this.thumbs.forEach(thumb => {
      thumb.addEventListener('click', (e) => this.handleThumbClick(e));
    });
  }
  
  handleThumbClick(e) {
    const thumb = e.currentTarget;
    const videoIndex = thumb.dataset.videoThumb;
    
    // Don't do anything if already active
    if (thumb.classList.contains('is-active')) {
      return;
    }
    
    // Switch to this video
    this.switchToVideo(videoIndex);
  }
  
  switchToVideo(index) {
    // Update thumbnails
    this.thumbs.forEach(thumb => {
      const isActive = thumb.dataset.videoThumb === index;
      thumb.classList.toggle('is-active', isActive);
    });
    
    // Update main players
    this.players.forEach(player => {
      const isActive = player.dataset.videoPlayer === index;
      const wasActive = player.classList.contains('is-active');
      
      if (isActive && !wasActive) {
        // Show this player
        player.classList.add('is-active');
        
        // Try to autoplay the video
        this.playVideo(player);
        
      } else if (!isActive && wasActive) {
        // Hide and pause this player
        player.classList.remove('is-active');
        this.pauseVideo(player);
      }
    });
  }
  
  playVideo(playerWrapper) {
    const video = playerWrapper.querySelector('video');
    const iframe = playerWrapper.querySelector('iframe');
    
    if (video) {
      // HTML5 video
      video.currentTime = 0;
      video.play().catch(e => {
        // Autoplay might be blocked - that's ok
        console.log('[VideoGallery] Autoplay blocked:', e.message);
      });
    } else if (iframe) {
      // YouTube/Vimeo - reload iframe to start from beginning with autoplay
      const currentSrc = iframe.src;
      // Add/replace autoplay parameter
      let newSrc = currentSrc.replace(/autoplay=[01]/, 'autoplay=1');
      if (!newSrc.includes('autoplay=')) {
        newSrc += (newSrc.includes('?') ? '&' : '?') + 'autoplay=1';
      }
      iframe.src = newSrc;
    }
  }
  
  pauseVideo(playerWrapper) {
    const video = playerWrapper.querySelector('video');
    const iframe = playerWrapper.querySelector('iframe');
    
    if (video) {
      // HTML5 video
      video.pause();
    } else if (iframe) {
      // YouTube/Vimeo - stop by setting autoplay=0
      const currentSrc = iframe.src;
      const newSrc = currentSrc.replace(/autoplay=[01]/, 'autoplay=0');
      iframe.src = newSrc;
    }
  }
}

// Initialize when DOM is ready
function initVideoGalleries() {
  const galleries = document.querySelectorAll('.marlow-videos');
  galleries.forEach(section => {
    const sectionId = section.dataset.sectionId;
    if (sectionId) {
      new MarlowVideoGallery(sectionId);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initVideoGalleries);
} else {
  initVideoGalleries();
}

// Reinitialize on Shopify section render
document.addEventListener('shopify:section:load', (e) => {
  const sectionId = e.detail.sectionId;
  if (sectionId) {
    setTimeout(() => new MarlowVideoGallery(sectionId), 100);
  }
});
